var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-search-form-input mb-0 pb-0 ml-md-3"},[_c('input',{staticClass:"quick-search-input form-control",attrs:{"type":"search","placeholder":"What are you looking for?","aria-label":"Search"},domProps:{"value":_vm.searchInput},on:{"click":_vm.updateShow,"input":_vm.updateSearchInput}})])
}
var staticRenderFns = []

export { render, staticRenderFns }